import { Footer } from './footer';

const props = [
];

export const FooterDirective = reactDirective => reactDirective(Footer, props);
FooterDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('footer', FooterDirective);
